import React from 'react';
import { Input, Tooltip } from 'antd';

import { IPreviewCellProps } from './i-import-wizard';

const PreviewCell = ({
  value,
  error,
  disabled,
  onChange,
}: IPreviewCellProps): JSX.Element => {
  const input = (
    <Input
      size="small"
      value={value}
      disabled={disabled}
      status={error ? 'error' : ''}
      onChange={(event) => onChange(event.target.value)}
    />
  );

  if (!error) {
    return input;
  }

  return <Tooltip title={error}>{input}</Tooltip>;
};

PreviewCell.displayName = 'PreviewCell';

export default React.memo(PreviewCell);
